export const ERROR_CODES = {
    APPLICATION_ERROR: 'Error: Application Error',
};

export const ERRORCODE_MAP = new Map();
ERRORCODE_MAP.set(70006, ERROR_CODES.APPLICATION_ERROR);
